import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import routes from '~pages'
import {
  hasActiveSubscription,
  isUserLoggedIn,
  isUserRegisteredSuccessfully,
  canNavigateTo
} from './utils'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // ℹ️ We are redirecting to different pages based on role.
    // NOTE: Role is just for UI purposes. ACL is based on abilities.
    {
      path: '/',
      redirect: to => {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        const userRole = userData && userData.role ? userData.role : null
        if (userRole === 'admin')
          return { name: 'dashboard' }
        if (userRole === 'client')
          return { name: 'access-control' }

        return { name: 'login', query: to.query }
      },
    },
    {
      path: '/cmsRecommendation/cmsEditorMode/:id',
      redirect: to => {
        return {
          name: 'cmsRecommendation-cmsEditorMode', params: { pageData: {}, }, query: { page_id: '' }
        }
      },
      props: {
        // You must set `true` to the default view, which uses ProductDetail
        default: true
      }
    },
    {
      path: '/cmsRecommendation/cmsCreateMode/:id',
      redirect: to => {
        return {
          name: 'cmsRecommendation-cmsCreateMode', params: { pageData: {}, }, query: { page_id: '' }
        }
      },
      props: {
        // You must set `true` to the default view, which uses ProductDetail
        default: true
      }
    },
    {
      // redirect legacy dashboard path to new dashboard
      path: '/dashboards/overview',
      redirect: '/dashboard',
    },
    ...setupLayouts(routes),
  ],
  scrollBehavior(to) {
    // ℹ️ In-page anchor navigation (e.g. the table of contents on /legal/dataprivacy).
    // Without this the router would unconditionally scroll to the top and the anchor would never be reached.
    if (to.hash)
      return { el: to.hash, behavior: 'smooth' }

    return { top: 0 }
  },
})
router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  const registerSuccess = isUserRegisteredSuccessfully()
  const activeSubscription = hasActiveSubscription()

  if(to.meta.skipRedirect){
    return next()
  }

  if(!canNavigateTo(to.meta)) {
    // Redirect to login if not logged in
    // ℹ️ Only add `to` query param if `to` route is not index route
    if (!isLoggedIn)
      return next({ name: 'login', query: { to: to.name !== 'index' ? to.fullPath : undefined } })

    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  // quicker redirect to login page if the user is not logged in
    // No redirect special for login.vue so we do not have a deadloop to login page (special case handling for imposter login via token)
  if(!isLoggedIn && !to.meta.redirectIfLoggedIn && !to.meta.noRedirect) {
    return next({ name: 'login', query: { to: to.name !== 'index' ? to.fullPath : undefined } })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next({ name: 'dashboard' })
  }

  if (to.meta.redirectIfRegistrationSuccess && registerSuccess) {
    return next({ name: 'dashboard' })
  }

  if (to.meta.redirectIfSubscriptionActive && activeSubscription && registerSuccess) {
    return next({ name: 'dashboard' })
  }

  return next()
})
export default router
